// 指定图表的配置项和数据
export var option = {
  title: {
    text: '',
    x: '15',
    y: 'top',
    textAlign: 'left',
    textStyle: {
      color: '#fff',
      fontSize: 16
    }
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['去年', '今年'],
    textStyle: {
      fontSize: 18,
      color: '#fff'
    },
    x: '5%'
  },
  xAxis: [{
    splitLine: {
      show: false, // 隐藏内部线
      lineStyle: {
        color: '#141e34'
      }
    }, // 隐藏内部线
    type: 'category',
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1 // 这里是为了突出显示加上的
      }
    },
    axisLabel: {
      interval: 1,
      rotate: 0,
      textStyle: { // 刻度值的字体样式设置
        color: '#7591d8',
        fontSize: 20
      },
      margin: 20
    },
    boundaryGap: false,
    data: []
  }],
  yAxis: [{

    type: 'value',
    axisLine: {
      lineStyle: {
        color: '#fff',
        width: 1 // 这里是为了突出显示加上的
      }
    },
    axisLabel: {
      textStyle: { // 刻度值的字体样式设置
        color: '#7591d8',
        fontSize: 20
      },
      margin: 20
      // 刻度值离轴线多远的距离
    }
  }],
  series: [{
    name: '最高',
    type: 'line',
    data: [],
    smooth: true,
    lineStyle: {
      normal: {
        width: 5,
        color: 'blue'
      }
    }
  }
    // {
    //     name: '最低',
    //     type: 'line',
    //     data: function () {
    //         var list = [];
    //         for (var i = 1; i <= 30; i++) {
    //             list.push(Math.round(Math.random() * 10));
    //         }
    //         return list;
    //     }()
    // }
  ]
}
